import { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { translations } from "@/i18n/translations";

export const SLUGS = {
  de: {
    home: "", services: "leistungen", machines: "maschinenpark", gallery: "werkstuecke",
    about: "ueber-uns", contact: "kontakt", inquiry: "anfrage",
    imprint: "impressum", privacy: "datenschutz", cookies: "cookies",
  },
  it: {
    home: "", services: "servizi", machines: "parco-macchine", gallery: "pezzi",
    about: "chi-siamo", contact: "contatti", inquiry: "richiesta",
    imprint: "note-legali", privacy: "privacy", cookies: "cookie",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = location.pathname.startsWith("/it") ? "it" : "de";

  const value = useMemo(() => {
    const pathFor = (key) => {
      const slug = SLUGS[lang][key] ?? "";
      return `/${lang}${slug ? `/${slug}` : ""}`;
    };
    const otherLang = lang === "de" ? "it" : "de";
    const currentSlug = location.pathname.replace(/^\/(de|it)\/?/, "").replace(/\/$/, "");
    const currentKey = Object.keys(SLUGS[lang]).find((k) => SLUGS[lang][k] === currentSlug) || "home";
    const switchPath = `/${otherLang}${SLUGS[otherLang][currentKey] ? `/${SLUGS[otherLang][currentKey]}` : ""}`;
    const switchLang = () => navigate(switchPath);
    return { lang, t: translations[lang], pathFor, switchLang, switchPath, otherLang };
  }, [lang, location.pathname, navigate]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function fileUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
